import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Camera: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7319 5.92859C14.7319 5.6539 14.6227 5.39046 14.4285 5.19622C14.2343 5.002 13.9708 4.89287 13.6961 4.89287H11.8836L10.3301 2.30359H5.66936L4.11579 4.89287H2.30329C2.0286 4.89287 1.76517 5.002 1.57093 5.19622C1.3767 5.39046 1.26758 5.6539 1.26758 5.92859V12.6607C1.26758 12.9354 1.3767 13.1989 1.57093 13.3931C1.76517 13.5873 2.0286 13.6964 2.30329 13.6964H13.6961C13.9708 13.6964 14.2343 13.5873 14.4285 13.3931C14.6227 13.1989 14.7319 12.9354 14.7319 12.6607V5.92859Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99944 11.3984C9.42946 11.3984 10.5887 10.2392 10.5887 8.8092C10.5887 7.37917 9.42946 6.21991 7.99944 6.21991C6.56942 6.21991 5.41016 7.37917 5.41016 8.8092C5.41016 10.2392 6.56942 11.3984 7.99944 11.3984Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
